import ApiService from './api.service';

// Constant
const baseUrl = 'learning/';

const LearnService = {
	/**
	 * Start training new model
	 * @param {Params} params
	 * @returns {Response} response
	 */
	startLearning(params) {
		return ApiService.post(baseUrl + 'start', params);
	},
	/**
	 * Start training new model
	 * @param {Params} params
	 * @returns {Response} response
	 */
	retrain(params) {
		return ApiService.post(baseUrl + 'retrain', params);
	},
};

export default LearnService;
